
export class VocabCategoryCreationDto {
    constructor(
        public id: number,
        public name: string,
        public parentId: number,
        public isRoot: boolean,
        public isWordField: boolean,
        public isDach: boolean
    ) {
    }
}
